// =============================================================================
// Product gallery — main image Swiper wired to a thumbnail Swiper.
// =============================================================================
(function ($) {
    'use strict';

    $(function () {
        if (typeof Swiper === 'undefined') { return; }

        const $main   = $('[data-product-gallery-main]');
        const $thumbs = $('[data-product-gallery-thumbs]');
        if (!$main.length || !$thumbs.length) { return; }

        const thumbsSwiper = new Swiper($thumbs[0], {
            slidesPerView: 'auto',
            spaceBetween: 8,
            watchSlidesProgress: true,
            navigation: {
                prevEl: '.product-gallery__nav--prev',
                nextEl: '.product-gallery__nav--next',
            },
            breakpoints: {
                0:    { slidesPerView: 3, spaceBetween: 6 },
                768:  { slidesPerView: 4, spaceBetween: 8 },
            },
        });

        new Swiper($main[0], {
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 350,
            watchOverflow: true,
            keyboard: { enabled: true, onlyInViewport: true },
            a11y: {
                prevSlideMessage: 'Previous image',
                nextSlideMessage: 'Next image',
            },
            thumbs: { swiper: thumbsSwiper },
        });
    });
})(jQuery);
